<script setup lang="ts">
import { TrackingOrderProps } from "./TrackingOrder.props"

withDefaults(defineProps<TrackingOrderProps>(), {
  scheduledDeliveryDate: ""
})

const emit =
  defineEmits<{
    (e: "onStarClick", value: number)
  }>()

const handleStarClick = (value: number) => emit("onStarClick", value)
</script>

<template>
  <div class="tracking-order-wrapper bg-tiffany-10 px-4 pb-9 pt-8 md:shadow-01">
    <p class="elephant-bold mb-3 text-green-main">
      {{ $t("productBlocks.trackingOrder.orderStatus") }}
    </p>

    <p class="beaver mb-1">
      <span class="beaver-bold">
        {{ $t("productBlocks.trackingOrder.orderCreated") }}
      </span>
      <span>
        {{ orderDate }}
      </span>
    </p>

    <p class="beaver mb-11">
      <span class="beaver-bold">
        {{ $t("productBlocks.trackingOrder.orderNumber") }}
      </span>
      <span>
        {{ orderNumber }}
      </span>
    </p>

    <div
      v-if="scheduledDeliveryDate"
      class="
        mb-3
        flex
        items-center
        gap-2
        bg-gradient-to-r
        from-tiffany-30
        to-tiffany-60
        px-3
        py-8
      "
    >
      <UtilsIcon
        name="FilledCar.svg"
        color="green-main"
        class="h-5 w-5 text-green-main"
      />
      <p class="pig-bold">
        {{ scheduledDeliveryDate }}
      </p>
    </div>

    <div class="mb-3 flex gap-2 bg-white px-3 pb-4 pt-3">
      <UtilsIcon
        name="Home.svg"
        color="green-main"
        class="h-5 w-5 text-green-main"
      />

      <div class="flex flex-col gap-1">
        <p class="beaver-bold">
          {{ $t("productBlocks.trackingOrder.shipmentAddress") }}
        </p>

        <UtilsMarkdown class="mouse" :content="shipmentAddress" />
      </div>
    </div>

    <!-- <div class="mb-6 flex gap-2 bg-white p-3">
      <UtilsIcon name="Star.svg" color="green-main" class="h-5 w-5 text-green-main" />

      <div>
        <p class="beaver-bold mb-1">
          {{ $t("productBlocks.trackingOrder.askFeedback") }}
        </p>

        <p class="mouse mb-2 text-black-80">
          {{ $t("productBlocks.trackingOrder.importantOpinion") }}
        </p>

        <div class="flex gap-1">
          <UtilsIcon name="StarFilled.svg" color="grey-100"
            @click="handleStarClick(n)"
            v-for="n in 5"
            class="h-5 w-5 cursor-pointer text-grey-100"
          />
        </div>
      </div>
    </div> -->

    <UtilsButton
      @click="handleButtonClick"
      :to="path"
      class="custom-btn-pig-medium w-full"
      :text="$t('productBlocks.trackingOrder.viewOrderDetails')"
      theme="outlined-green"
    />
  </div>
</template>
